// NOT EKLE KISMININ AÇIKLAMA VE DOSYA YÜKLEME ALANINI TEMSİL EDİYOR. SONRASINDA DÜZENLEME ALANI İÇİN COMPENENT HALİNE GETİRİLEBİLİR. ŞUAN GEREKSİZ OLABİLİR.

import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  Box,
  Typography,
  TextField,
  List,
  ListItem,
  ListItemText,
  Paper,
  IconButton,
  Divider,
  Snackbar,
  Alert,
  Collapse,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";

function FileUploader({ description, setDescription, files, setFiles }) {
  const [errorOpen, setErrorOpen] = useState(false);
  const onDropRejected = () => {
    setErrorOpen(true);
  };
  useEffect(() => {
    if (errorOpen) {
      const timeout = setTimeout(() => setErrorOpen(false), 3000);
      return () => clearTimeout(timeout);
    }
  }, [errorOpen]);
  const onDrop = (acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        setFiles((prev) => [...prev, { name: file.name, data: base64String }]);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleDelete = (indexToDelete) => {
    setFiles((prev) => prev.filter((_, index) => index !== indexToDelete));
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    onDropRejected,
    maxSize: 7 * 1024 * 1024, // 7 MB sınırı
    noDrag: true,
    noClick: true,
  });

  return (
    <Paper
      elevation={0} // Gölgeyi tamamen kaldırır
      sx={{
        width: "100%",
        border: "none", // Kenar çizgilerini kaldırır
        background: "transparent", // Arkaplan rengini kaldırır (isteğe bağlı)
        boxShadow: "none", // Ekstra güvence için
      }}
    >
      <TextField
        label="Açıklama"
        multiline
        rows={4}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        variant="outlined"
        fullWidth
        sx={{ mb: 2, width: "100%" }}
      />
      <Box sx={{ mb: 2 }}>
        <input {...getInputProps()} />
        <IconButton
          color="primary"
          onClick={open}
          size="small"
          sx={{ bgcolor: "#e3f2fd", "&:hover": { bgcolor: "#bbdefb" } }}
        >
          <AttachFileIcon fontSize="small" />
        </IconButton>
        <Typography variant="caption" sx={{ ml: 1, color: "text.secondary" }}>
          Dosya Ekle
        </Typography>
      </Box>
      {files.length > 0 && (
        <>
          <Typography gutterBottom>Yükleme Dosyaları:</Typography>
          <List dense sx={{ bgcolor: "white", borderRadius: 1, mb: 2 }}>
            {files.map((file, index) => (
              <React.Fragment key={index}>
                <ListItem
                  sx={{ height: "auto" }}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => handleDelete(index)}
                      color="error"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  }
                >
                  <UploadFileIcon color="primary" sx={{ mr: 1 }} />
                  <ListItemText
                    primary={file.name}
                    primaryTypographyProps={{
                      style: {
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 350, // Adjust this value as needed
                      },
                    }}
                  />
                </ListItem>
                {index < files.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
          <Collapse in={errorOpen}>
            <Alert
              severity="error"
              onClose={() => setErrorOpen(false)}
              sx={{ mt: 2 }}
            >
              7 MB'den büyük dosyalar yüklenemez!
            </Alert>
          </Collapse>
        </>
      )}
    </Paper>
  );
}

export default FileUploader;
